<style>
	.table.table-form td,
	.table.table-form th {
		padding: .5em 0 0 .5em;
	}
</style>

<template>
	<div>
		<input type="hidden" name="consents" v-model="consentsJson">
		<table class="table table-striped table-form">
			<tr>
				<th>Form</th>
				<th>Date Signed</th>
				<th>Comments</th>
				<th></th>
			</tr>
			<tr>
				<td>
					<select v-model="newConsent.consent_form_id" class="form-control">
						<option value="">Select</option>
						<option v-for="form in consentForms" :key="'form_'+form.id" v-bind:value="form.id">
							{{ form.consent_form_type.name }}
							{{ form.version }}
							({{ form.added_at }})
						</option>
					</select>
				</td>
				<td><input type="date" class="form-control" v-model="newConsent.signed_at"></td>
				<td><input type="text" v-model="newConsent.notes" class="form-control"></td>
				<td><button type="button" class="btn btn-primary glyphicon glyphicon-plus" v-on:click="addConsent()"></button></td>
			</tr>
			<tr v-for="(consent, idx) in consents" :key="'consent_'+idx">
				<td>
					<select v-model="consent.consent_form_id" class="form-control">
						<option value="">Select</option>
						<option v-for="form in consentForms" :key="'consent_form_'+form.id" v-bind:value="form.id">
							{{ form.consent_form_type.name }}
							{{ form.version }}
							({{ form.added_at }})
						</option>
					</select>
				</td>
				<td><input type="date" class="form-control" v-model="consent.signed_at"></td>
				<td><input type="text" v-model="consent.notes" class="form-control"></td>
				<td><button type="button" class="btn btn-default glyphicon glyphicon-minus" v-on:click="removeConsent(consent)"></button></td>
			</tr>
		</table>
	</div>

</template>

<script setup>
	import { ref, computed, onMounted } from 'vue'
	
	const props = defineProps(['renderableName', 'consentForms'])
	const consents = ref([])
	const newConsent = ref({})

	const consentsJson = computed(() => {
		if(consents.value.length > 0) {
			return JSON.stringify(consents.value);
		}
		return null;
	})

	onMounted(() => {
		initNewConsent();
		if (props.renderableName) {
			consents.value = JSON.parse(props.renderableName);
		}
	})

	function addConsent() {
		if (newConsent.value.consent_form_id && newConsent.value.signed_at) {
			consents.value.push(newConsent.value)
			initNewConsent()
		}
	}

	function removeConsent(consent) {
		consents.value.splice(consents.value.indexOf(consent), 1);
	}

	function initNewConsent() {
		newConsent.value = {
			consent_form_id: null,
			signed_at: null,
			notes: null,				
		};			
	}

	function clearNewConsent() {
		newConsent.value = {}
	}
</script>